import React, { useState, useEffect, useCallback } from "react";
import Card from "@mui/material/Card";
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiButton from "components/SuiButton";
import Button from "@mui/material/Button";
import Table from "examples/Tables/Table";
import ProductSearch from "./productSearchbar";
import NoData from "containers/DataNotAvailBox";
import { ProductRows_ } from "./productRows.js";
import * as XLSX from "xlsx";
import { TailSpin } from "react-loader-spinner";
import { validateAndExtractCellValuesForProducts } from "validations/product";
import { downloadFileFromStorage } from "firebaseConfig";
import { downloadErrorsAsTxt } from "utils/helper";
import { addMultipleProducts } from "services/offering";
import { toast } from "react-toastify";
import { styled } from "@mui/material/styles";
import { validateExcelHeaders } from "validations";
import { excelAndDbProductFieldsMapping } from "constant";
import { clearInputValueByDocId } from "utils/common";
import { useDispatch } from "react-redux";
import { updateProductsAfterBulkUpload } from "store/features/dashboard";
import moment from "moment";
import { updateFirstLetter } from "utils/helper";

const InputFile = styled("input")({
  display: "none",
});

function ProductTable({
  products,
  adminId,
  isSuccess,
  isFetching,
  loader,
  addHandler,
  onSellHandler,
  editHandler,
  viewHandler,
  deleteHandler,
}) {
  const dispatch = useDispatch();

  const [productOptions, setProductOptions] = useState([]);

  useEffect(() => {
    let productArray = products.map((item) => {
      return {
        value: item?.productName,
        label: item?.productName,
      };
    });
    setProductOptions(productArray);
  }, [products]);

  const [rows, setRows] = useState([]); // rows for Product table

  const [searchVal, setsearchVal] = useState(""); //storing search input text
  const [productArray, setProductArray] = useState([]); //

  const columns = [
    { name: "S.no", align: "left" },
    { name: "Date/Time (Last Updated)", align: "left", minWidth: "175px" },
    { name: "Product", align: "left", minWidth: "160px" },
    { name: "Brand", align: "left", minWidth: "110px" },
    // { name: "Product description", align: "left", minWidth: "180px" },
    { name: "Cost price WT", align: "left", minWidth: "120px" },
    // { name: "Cost price WOT", align: "left", minWidth: "180px" },
    { name: "MRP", align: "left" },
    // { name: "Tax(%)", align: "left" },
    // { name: "Tax amount", align: "left", minWidth: "120px" },
    // { name: "Status", align: "left", minWidth: "120px" },
    { name: "Available Quantity", align: "left", minWidth: "150px" },
    { name: "Action", align: "left", minWidth: "120px" },
  ];

  useEffect(() => {
    setRows(
      ProductRows_(
        productArray,
        onSellHandler,
        editHandler,
        deleteHandler,
        viewHandler
      )
    );
  }, [productArray, onSellHandler, editHandler, deleteHandler, viewHandler]);

  const [filterQuery, setFilterQuery] = useState({
    status: null,
    product: null,
  }); // for filtering

  const filterHandler = () => {
    setsearchVal("");
    let filterData = products.filter((item) => {
      if (filterQuery.status) {
        if (filterQuery.status === "all") {
          setFilterQuery({ ...filterQuery, status: null });
        } else if (filterQuery.status === "Sold out") {
          if (item.availableQuantity > 0) {
            return false;
          }
        } else if (filterQuery.status === "Available") {
          if (item.availableQuantity === 0) {
            return false;
          }
        }
      }

      if (filterQuery.product) {
        if (filterQuery.product === "all") {
          setFilterQuery({ ...filterQuery, product: null });
        } else if (filterQuery.product !== item["productName"]) {
          return false;
        }
      }

      return item;
    });
    setProductArray(filterData);
  };

  const resetHandler = useCallback(() => {
    setFilterQuery({
      status: null,
      product: null,
    });
    setProductArray(products);
  }, [products]);

  useEffect(() => {
    let filtered = [...products];

    if (filterQuery.product && filterQuery.product !== "all") {
      filtered = filtered.filter(
        (item) => item.productName === filterQuery.product
      );
    }

    if (filterQuery.status && filterQuery.status !== "all") {
      if (filterQuery.status === "Sold out") {
        filtered = filtered.filter((item) => item.availableQuantity === 0);
      } else if (filterQuery.status === "Available") {
        filtered = filtered.filter((item) => item.availableQuantity > 0);
      }
    }

    if (searchVal) {
      filtered = filtered.filter((s) =>
        s.productName.toLowerCase().includes(searchVal.toLowerCase())
      );
    }

    setProductArray(filtered);
  }, [products, filterQuery, searchVal]);

  const excelDownload = () => {
    let updatedData = products.map((item, index) => {
      return [
        index + 1,
        item.productName,
        item?.updatedAt
          ? moment(item?.updatedAt).local().format("DD/MM/YYYY h:mm a")
          : moment(item?.createdAt).local().format("DD/MM/YYYY h:mm a"),
        item.brand,
        item.description,
        (item.costPriceWOT * item.gst) / 100 + item.costPriceWOT,
        item.costPriceWOT,
        item.mrp,
        item.gst,
        (item.costPriceWOT * item.gst) / 100,
        item.availableQuantity,
        item.unit ? updateFirstLetter(item.unit.value) : "",
      ];
    });
    let excelData = [
      [
        "id",
        "PRODUCT",
        "DATE/TIME (LAST UPDATED)",
        "BRAND",
        "PRODUCT DESCRIPTION",
        "COST PRICE WT",
        "COST PRICE WOT",
        "MRP",
        "TAX(%)",
        "TAX AMOUNT",
        "Available Quantity",
        "Unit",
      ],
      ...updatedData,
    ];

    let workbook = XLSX.utils.book_new();
    let worksheet = XLSX.utils.json_to_sheet(excelData);
    XLSX.utils.book_append_sheet(workbook, worksheet, "MySheet");
    XLSX.writeFile(workbook, "Product_Inventory_Listing.xlsx");
  };

  const [excelUploadLoader, setExcelUploadLoader] = useState(false);

  const handleExcelUpload = (e) => {
    e.preventDefault();
    var files = e.target.files,
      f = files[0];
    f && setExcelUploadLoader(true);

    e.target.files = null;
    var reader = new FileReader();
    reader.onload = async function (e) {
      var data = e.target.result;
      let readedData = XLSX.read(data, { type: "binary" });
      const wsname = readedData.SheetNames[0];
      const ws = readedData.Sheets[wsname];
      const dataParse = XLSX.utils.sheet_to_json(ws, {
        header: 1,
        blankrows: false,
      });
      if (!validateExcelHeaders(dataParse, excelAndDbProductFieldsMapping)) {
        setExcelUploadLoader(false);
        clearInputValueByDocId("recipe-excel-file");
        return;
      }
      const { extractedData, errors } =
        await validateAndExtractCellValuesForProducts(dataParse, adminId);
      if (errors && errors.length > 0) {
        downloadErrorsAsTxt(errors, "product_errors.txt");
        toast.error(
          "Please check the errors in the downloaded file and try again!!"
        );
        setExcelUploadLoader(false);
        clearInputValueByDocId("recipe-excel-file");

        return;
      }
      try {
        const newProducts = await addMultipleProducts(extractedData);
        dispatch(updateProductsAfterBulkUpload([...newProducts, ...products]));
        setProductArray((e) => [...newProducts, ...e]);
        toast.success("Products added successfully!!");
        clearInputValueByDocId("recipe-excel-file");
      } catch (error) {
        clearInputValueByDocId("recipe-excel-file");
        toast.error("Something went wrong, please try again!!");
      }
      setExcelUploadLoader(false);
    };
    f && reader.readAsBinaryString(f);
  };

  const downloadExcelFile = async () => {
    try {
      await downloadFileFromStorage("templates/products.xlsx", "products.xlsx");
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <SuiBox mb={3}>
      <Card style={{ overflow: "inherit" }}>
        <SuiBox
          className="search-div"
          display="flex"
          justifyContent="space-between"
          flexWrap="wrap"
          alignItems="center"
          p={3}
          pb={0}
          flexDirection={{ xs: "column-reverse", xl: "row" }}
          gap={3}
        >
          <SuiTypography
            variant="button"
            fontWeight="regular"
            color={"dark"}
            sx={{ mb: 1 }}
          >
            Below are your products, you can add, edit, delete and sell
            products.
          </SuiTypography>

          <SuiBox
            className="search-box-div"
            display="flex"
            alignItems="center"
            flexWrap="wrap"
            gap={2}
            justifyContent={{ xs: "center", lg: "flex-end" }}
          >
            <SuiButton
              component={Button}
              color="dark"
              variant="gradient"
              onClick={addHandler}
              width={180}
              style={styles.button}
            >
              Add new product
            </SuiButton>

            <label htmlFor="recipe-excel-file" style={{ cursor: "pointer" }}>
              <InputFile
                id="recipe-excel-file"
                type="file"
                accept=".xlsx, .xls"
                onChange={handleExcelUpload}
              />
              <SuiButton
                ml={2}
                component={SuiTypography}
                color="dark"
                variant="gradient"
                onClick={(e) => e.stopPropagation()}
                style={styles.button}
              >
                Bulk Upload Products
                {excelUploadLoader && (
                  <TailSpin color="#17c1e8" height={17} width={17} />
                )}
              </SuiButton>
            </label>

            <SuiButton
              component={Button}
              color="dark"
              variant="gradient"
              onClick={downloadExcelFile}
              width={180}
              style={{ ...styles.button, marginLeft: 25 }}
            >
              Download excel template
            </SuiButton>
          </SuiBox>
        </SuiBox>

        <ProductSearch
          productOptions={productOptions}
          setFilterQuery={setFilterQuery}
          filterHandler={filterHandler}
          filterQuery={filterQuery}
          resetHandler={resetHandler}
          excelDownload={excelDownload}
        />

        {!loader ? (
          <SuiBox
            sx={{
              "& .MuiTableRow-root:not(:last-child)": {
                "& td": {
                  borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                    `${borderWidth[1]} solid ${borderColor}`,
                },
              },
            }}
          >
            {rows.length ? <Table columns={columns} rows={rows} /> : <NoData />}
          </SuiBox>
        ) : (
          <SuiBox style={{ display: "flex", justifyContent: "center" }} mb={4}>
            <TailSpin color="#17c1e8" height={60} width={60} />
          </SuiBox>
        )}
      </Card>
    </SuiBox>
  );
}

export default ProductTable;

/**-----------styles------------- */

const styles = {
  addProductButton: {
    marginRight: 25,
    marginBottom: 10,
    height: 40,
    width: 230,
    color: "#3A416F",
    padding: 10,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
};
